import { render, staticRenderFns } from "./CardCurrentJobs.vue?vue&type=template&id=21307925"
import script from "./CardCurrentJobs.vue?vue&type=script&lang=js"
export * from "./CardCurrentJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports